import React from 'react';
import meepleImg from '../img/meeple3.png';

function makeTooltip(pos, runner) {
    if (!runner) return undefined;
    const name = runner.name ?? 'Runner';
    const variation = runner.variationName ? ` (${runner.variationName})` : '';
    const base = `${pos} - ${name}${variation}`;
    return runner.speed != null ? `${base}\n${runner.speed} speed` : base;
}

function DayScene() {
    return (
        <svg
            viewBox="0 0 600 76"
            preserveAspectRatio="xMidYMin slice"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="rsd-sky" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#4a8ab5" />
                    <stop offset="100%" stopColor="#8ec4dc" />
                </linearGradient>
                <pattern id="rsd-fence" x="0" y="0" width="18" height="14" patternUnits="userSpaceOnUse">
                    <rect width="17" height="14" fill="#9c6b38" />
                    <rect x="17" width="1" height="14" fill="#6b3a12" />
                    <rect x="2" y="1" width="13" height="1" fill="rgba(255,255,255,0.06)" />
                </pattern>
            </defs>
            <rect x="0" y="0" width="600" height="26" fill="url(#rsd-sky)" />
            <ellipse cx="90" cy="9" rx="28" ry="9" fill="rgba(255,255,255,0.6)" />
            <ellipse cx="115" cy="5" rx="20" ry="11" fill="rgba(255,255,255,0.6)" />
            <ellipse cx="400" cy="10" rx="22" ry="7" fill="rgba(255,255,255,0.45)" />
            <ellipse cx="425" cy="5" rx="16" ry="9" fill="rgba(255,255,255,0.45)" />
            <rect x="0" y="18" width="600" height="14" fill="url(#rsd-fence)" />
            <rect x="0" y="18" width="600" height="3" fill="#5a2e08" />
            <rect x="0" y="31" width="600" height="3" fill="rgba(0,0,0,0.18)" />
            <rect x="0" y="28" width="600" height="48" fill="#5c8c3a" />
            <rect x="0" y="32" width="600" height="6" fill="rgba(0,0,0,0.05)" />
            <rect x="0" y="46" width="600" height="6" fill="rgba(0,0,0,0.05)" />
            <rect x="0" y="60" width="600" height="6" fill="rgba(0,0,0,0.05)" />
            <rect x="0" y="28" width="600" height="4" fill="rgba(255,255,255,0.08)" />
        </svg>
    );
}

function GoldenScene() {
    return (
        <svg
            viewBox="0 0 600 76"
            preserveAspectRatio="xMidYMin slice"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="rsg-sky" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#a83b10" />
                    <stop offset="55%" stopColor="#e07820" />
                    <stop offset="100%" stopColor="#f0c060" />
                </linearGradient>
                <pattern id="rsg-fence" x="0" y="0" width="18" height="14" patternUnits="userSpaceOnUse">
                    <rect width="17" height="14" fill="#3a2008" />
                    <rect x="17" width="1" height="14" fill="#22120a" />
                    <rect x="2" y="1" width="13" height="1" fill="rgba(255,180,60,0.08)" />
                </pattern>
            </defs>
            <rect x="0" y="0" width="600" height="26" fill="url(#rsg-sky)" />
            <ellipse cx="520" cy="10" rx="22" ry="20" fill="rgba(255,220,80,0.3)" />
            <ellipse cx="520" cy="10" rx="10" ry="9" fill="rgba(255,240,140,0.5)" />
            <rect x="0" y="18" width="600" height="14" fill="url(#rsg-fence)" />
            <rect x="0" y="18" width="600" height="4" fill="#1e0e04" />
            <rect x="0" y="31" width="600" height="3" fill="rgba(0,0,0,0.25)" />
            <rect x="0" y="28" width="600" height="48" fill="#7a9030" />
            <rect x="0" y="32" width="600" height="6" fill="rgba(0,0,0,0.06)" />
            <rect x="0" y="46" width="600" height="6" fill="rgba(0,0,0,0.06)" />
            <rect x="0" y="60" width="600" height="6" fill="rgba(0,0,0,0.06)" />
            <rect x="0" y="55" width="600" height="21" fill="rgba(220,140,20,0.08)" />
        </svg>
    );
}

function NightScene() {
    return (
        <svg
            viewBox="0 0 600 76"
            preserveAspectRatio="xMidYMin slice"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient id="rsn-sky" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#0a0e1e" />
                    <stop offset="100%" stopColor="#1a2640" />
                </linearGradient>
                <pattern id="rsn-fence" x="0" y="0" width="18" height="14" patternUnits="userSpaceOnUse">
                    <rect width="17" height="14" fill="#3c3020" />
                    <rect x="17" width="1" height="14" fill="#221a0e" />
                    <rect x="2" y="1" width="13" height="1" fill="rgba(255,220,120,0.06)" />
                </pattern>
                <radialGradient id="rsn-lightL" cx="20%" cy="0%" r="50%">
                    <stop offset="0%" stopColor="rgba(255,230,140,0.25)" />
                    <stop offset="100%" stopColor="rgba(255,230,140,0)" />
                </radialGradient>
                <radialGradient id="rsn-lightR" cx="80%" cy="0%" r="50%">
                    <stop offset="0%" stopColor="rgba(255,230,140,0.25)" />
                    <stop offset="100%" stopColor="rgba(255,230,140,0)" />
                </radialGradient>
            </defs>
            <rect x="0" y="0" width="600" height="26" fill="url(#rsn-sky)" />
            <circle cx="50" cy="5" r="1" fill="rgba(255,255,255,0.7)" />
            <circle cx="130" cy="3" r="1" fill="rgba(255,255,255,0.6)" />
            <circle cx="200" cy="8" r="1" fill="rgba(255,255,255,0.8)" />
            <circle cx="290" cy="3" r="1" fill="rgba(255,255,255,0.5)" />
            <circle cx="360" cy="6" r="1.2" fill="rgba(255,255,255,0.7)" />
            <circle cx="440" cy="4" r="1" fill="rgba(255,255,255,0.6)" />
            <circle cx="520" cy="9" r="1" fill="rgba(255,255,255,0.7)" />
            <circle cx="570" cy="4" r="1" fill="rgba(255,255,255,0.5)" />
            <circle cx="80" cy="2" r="4" fill="rgba(255,240,180,0.9)" />
            <circle cx="520" cy="2" r="4" fill="rgba(255,240,180,0.9)" />
            <rect x="0" y="0" width="600" height="76" fill="url(#rsn-lightL)" />
            <rect x="0" y="0" width="600" height="76" fill="url(#rsn-lightR)" />
            <rect x="0" y="18" width="600" height="14" fill="url(#rsn-fence)" />
            <rect x="0" y="18" width="600" height="4" fill="#1a1006" />
            <rect x="0" y="31" width="600" height="3" fill="rgba(0,0,0,0.3)" />
            <rect x="0" y="28" width="600" height="48" fill="#1e4020" />
            <rect x="0" y="32" width="600" height="6" fill="rgba(0,0,0,0.08)" />
            <rect x="0" y="46" width="600" height="6" fill="rgba(0,0,0,0.08)" />
            <rect x="0" y="60" width="600" height="6" fill="rgba(0,0,0,0.08)" />
        </svg>
    );
}

const SCENES = {
    day: DayScene,
    golden: GoldenScene,
    night: NightScene,
};

function EmptyBase({ posClass }) {
    return (
        <span className={`empty-base ${posClass}`}>
            <svg viewBox="0 0 30 10" className="empty-base-svg">
                <polygon points="15,0.5 29,5 15,9.5 1,5" fill="white" stroke="rgba(0,0,0,0.2)" strokeWidth="0.8" />
            </svg>
        </span>
    );
}

function Meeple({ posClass, runner, meepleConfig, basePos }) {
    if (!runner) return <EmptyBase posClass={posClass} />;
    const baseName = posClass.replace('meeple-', '');
    const customSrc = runner.isUser && meepleConfig?.basePath
        ? `${meepleConfig.basePath}/${baseName}.png`
        : null;
    const userClass = runner.isUser ? ' meeple-user' : '';
    const varClass = runner.variationCss ? ` ${runner.variationCss}` : '';
    const maskStyle = runner.variationCss
        ? { '--meeple-mask': `url(${meepleImg})` }
        : undefined;
    // When base positions are supplied (stadium diamond), anchor the meeple's feet
    // (bottom-center) at the base's spot in the runners box, forming the diamond.
    const diamondStyle = basePos
        ? { left: basePos.left, right: 'auto', top: basePos.top, bottom: 'auto', transform: 'translate(-50%, -100%)' }
        : undefined;
    return (
        <span className={`meeple-pin ${posClass}${varClass}`} style={{ ...maskStyle, ...diamondStyle }}>
            <img className={`meeple-img${userClass}`} src={customSrc || meepleImg} alt={`Runner on base`} />
        </span>
    );
}

function RunnersDisplay({ firstBase, secondBase, thirdBase, theme = 'day', hideScene = false, meepleConfig, bases }) {
    const Scene = SCENES[theme] ?? SCENES.day;

    return (
        <div className={`runners-panel${hideScene ? ' runners-panel--stadium' : ''}`}>
            {!hideScene && <Scene />}
            <Meeple posClass="meeple-3b" runner={thirdBase} meepleConfig={meepleConfig} basePos={bases?.third} />
            <Meeple posClass="meeple-2b" runner={secondBase} meepleConfig={meepleConfig} basePos={bases?.second} />
            <Meeple posClass="meeple-1b" runner={firstBase} meepleConfig={meepleConfig} basePos={bases?.first} />
            <div className={`base-zone base-zone-3b${thirdBase ? ' occupied' : ''}`} data-tooltip={makeTooltip('3rd', thirdBase) ?? '3rd'} />
            <div className={`base-zone base-zone-2b${secondBase ? ' occupied' : ''}`} data-tooltip={makeTooltip('2nd', secondBase) ?? '2nd'} />
            <div className={`base-zone base-zone-1b${firstBase ? ' occupied' : ''}`} data-tooltip={makeTooltip('1st', firstBase) ?? '1st'} />
        </div>
    );
}

export default RunnersDisplay;
